import { faShop } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { PageHeader } from "../../../../../shared/components/pageHeader/PageHeader"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { Page } from "../../../../../shared/components/pageHeader/PageHeaderApi"
import { MERCHANT_ADMIN_ROUTE } from "../../../../../constants/routes"
import {
    Breadcrumb,
    BreadcrumbLink,
    StandardBreadcrumbs,
} from "../../../../../shared/components/links/StandardBreadcrumbs"
import { IdCardsTable } from "../components/IdCardsTable"

type Props = Readonly<{}>

export function MerchantIdCards({}: Props) {
    return (
        <>
            <LocalizedStrict id="merchant-reports-id-cards-title" attrs={{ title: true }}>
                <PageHeader page={Page.MERCHANT_ID_CARDS} title="ID cards" icon={<FontAwesomeIcon icon={faShop} />}>
                    <StandardBreadcrumbs>
                        <LocalizedStrict id="merchant-reports-id-cards-nav-item-home">
                            <BreadcrumbLink to={MERCHANT_ADMIN_ROUTE}>Home</BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="merchant-nav-item-id-cards-header">
                            <Breadcrumb>ID cards</Breadcrumb>
                        </LocalizedStrict>
                        <LocalizedStrict id="merchant-reports-id-cards-nav-item-id-cars">
                            <Breadcrumb>ID cards</Breadcrumb>
                        </LocalizedStrict>
                    </StandardBreadcrumbs>
                </PageHeader>
            </LocalizedStrict>

            <IdCardsTable />
        </>
    )
}
